export type Group = {
  liveWeightJuvenileValuePerKg?: number;
  breedingMotherValuePerHead?: number;
  breedingMotherInitialHeadCount?: number;
};

export type GroupValidation = {
  [key in keyof Group]: boolean;
};

export const getGroupValidation = (herd: Group) => {
  const validation: GroupValidation = {
    liveWeightJuvenileValuePerKg:
      herd.liveWeightJuvenileValuePerKg !== undefined &&
      herd.liveWeightJuvenileValuePerKg >= 0.01,
    breedingMotherValuePerHead:
      herd.breedingMotherValuePerHead !== undefined &&
      herd.breedingMotherValuePerHead > 0.01,
    breedingMotherInitialHeadCount:
      herd.breedingMotherInitialHeadCount !== undefined &&
      herd.breedingMotherInitialHeadCount > 0,
  };
  return [Object.values(validation).every((v) => v), validation] as const;
};
